// modules
import { createAction } from 'redux-actions'

// actions
export const setPatientEnrollments = createAction('SET_PATIENT_ENROLLMENTS')
export const setIsEnrollmentsUpdated = createAction(
  'SET_IS_ENROLLMENTS_UPDATED'
)
